import api from '@/lib/axios';

class QuestionnaireService {
  async getInitialUserData(userId) {
    const response = await api.get(`/v1/get-Intial-user-data`, {
      params: { user_id: userId }
    });
    return response.data;
  }

  async getLegacyInitialUserData(userId) {
    const response = await api.post(`/v1/legacyget-Intial-user-data`, {
      user_id: userId
    });
    return response.data;
  }

  async saveStepData(payload) {
    try {
      const response = await api.post(`/v1/save-step`, payload);
      return response.data;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        throw new Error(error.response.data?.message || 'Failed to save step data');
      } else if (error.request) {
        // The request was made but no response was received
        throw new Error('No response received from server');
      } else {
        // Something happened in setting up the request
        throw new Error('Error setting up the request');
      }
    }
  }
}

export const questionnaireService = new QuestionnaireService(); 